/**
 * #1 General contact form — /contact, the home page and every page that
 * embeds <ContactForm />. Page context (product, category, industry,
 * location, platform, case study) arrives via `context` and is used to
 * pre-fill Needs / Industry and to label the Lead.
 */
import {
  company, currentProvider, email, firstName, lastName, message, needs, phone, replyFooter,
} from "./common";

/** URL/prop `category` → Zoho Needs value. */
export const CATEGORY_NEEDS = {
  "card-machines": "Card machine",
  "epos-systems": "EPOS",
  "online-payments": "Online payments",
  "payment-gateway": "Online payments",
  integrations: "Online payments",
  "online-ordering": "Online payments",
  funding: "Merchant cash advance",
};

const contactGeneral = {
  id: "contact_general",
  label: "Contact form",
  crm: {
    layout: "Standard",
    leadSource: "Website Contact Form",
    tags: (values, ctx) => (ctx.product ? [`Product: ${ctx.product}`] : []),
  },
  fields: [
    [firstName, lastName],
    [email, phone],
    company,
    needs,
    currentProvider,
    message,
  ],
  submitLabel: "Send my details",
  footer: replyFooter,
  consent: { variant: "standard" },
  success: { allowReset: true },
  contextToCrm: (ctx) => ({
    Needs: CATEGORY_NEEDS[ctx.category] ? [CATEGORY_NEEDS[ctx.category]] : [],
    IndustrySector: ctx.industryLabel || "",
  }),
  summary: (values, ctx) => {
    const about = [ctx.product, ctx.industryLabel, ctx.locationLabel, ctx.platformLabel].filter(Boolean);
    return about.length ? `Website enquiry: ${about.join(" · ")}` : "Website enquiry";
  },
};

export default contactGeneral;
